import React from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from '@common/hooks/translation';
import Config from '@skin_config';

import './style.scss';

const HomeShortPages = () => {
  const t = useTranslation();

  return (
    <div className="home-short-pages">
      {Config.homePagesUrl.map((page) => {
        if (!page) return null;

        return (
          <Link
            key={page.id}
            to={page.url}
          >
            <p className={page.className}>
              <i className={page.icon} />
              {t(page.name)}
            </p>
          </Link>
        );
      })}
    </div>
  );
};

export default HomeShortPages;
